import {UISTATES} from '../enum';

/**
 * getHintSuggestion()
 * Returns `term` if it contains `search` (case insensitive).  `term` is returned in the same casing as `search`
 * @param {string} search
 * @param {string} term
 */
export function getHintSuggestion(search, term) {
    if (!search || !term) {
        return '';
    }
    let fullMatch = true;
    let hintSuggestion = '';
    let i = 0;
    for (i = 0; i < search.length; i++) {
        let searchChar = search[i];
        let termChar = term[i];
        if (
            searchChar &&
            termChar &&
            searchChar.toLowerCase() !== termChar.toLowerCase()
        ) {
            fullMatch = false;
            break;
        } else {
            hintSuggestion += searchChar;
        }
    }
    if (fullMatch !== false) {
        hintSuggestion += term.substr(search.length);
    } else {
        hintSuggestion = '';
    }
    return hintSuggestion;
}

/**
 * focusSearchInput()
 * Maintain focus on searchinput when in select destination state
 * @param {*} state
 */
export function focusSearchInput(state) {
    if (state.uistate !== UISTATES.SELECT_DESTINATION) {
        return {uistate: UISTATES.SELECT_DESTINATION};
    }
    return false;
}

/**
 * highlightResults()
 * Enhance returned results with computed highlights
 * TODO: optimize o(n^2) algorithm
 */
export function highlightResults(search, results) {
    let index = 0;
    let dupeDict = {}; // do not compute dupes
    let computedResults = [];
    let computedResult = null;

    for (let i = 0; i < results.length; i++) {
        let result = results[i];
        let previouslyComputedResult = dupeDict[result.uuid];
        if (previouslyComputedResult) {
            // Continue in loop and do not re-compute highlight
            continue;
        } else {
            computedResult = {highlightedTerm: [], ...result};
            dupeDict[result.uuid] = computedResult;
        }

        let placeFullname = computedResult.term;
        index = 0;

        for (let j = 0; j < placeFullname.length; j++) {
            let highlighted =
                index < search.length &&
                placeFullname[j].toLowerCase() === search[index].toLowerCase();
            if (highlighted) {
                index++;
            }
            computedResult.highlightedTerm[j] = {
                value: placeFullname[j],
                highlighted
            };
        }
        computedResults.push(computedResult);
    }
    return computedResults;
}

/**
 * isValidPropertyId()
 * Returns boolean to indicate if it's a valid property id
 * Valid property ids:
 * p1078525vb 1078525vb 1078525 ...
 * more suffixes you can find here:
 * https://github.homeawaycorp.com/hacommons/global-config-service/blob/master/data/src/main/resources/global-config/common/data-stores.json
 * @param {string} search
 */
export function isValidPropertyId(search) {
    return search.match(/^p?(\d+)(ha|vb|tr|a|d|o|r|h|)$/) !== null;
}
